import Splide from '@splidejs/splide'

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	const bannerPrev = document.querySelector('.js-banner-slider-prev')
	const bannerNext = document.querySelector('.js-banner-slider-next')

	if (bannerElements ) {
		const banner = new Splide('.js-banner-slider', {
			type: 'fade',
			arrows: false,
			pagination: false,
			keyboard: false,
			drag: true,
			rewind: true,
			autoplay: true,
			speed: 2000,
			interval: 4000,
			pauseOnHover: false,
			snap: true,
			autoHeight: true,
		}).mount()

		if (bannerPrev && bannerNext) {
			bannerPrev.addEventListener('click', () => {
				banner.go('-1')
			})
			
			bannerNext.addEventListener('click', () => {
				banner.go('+1')
			})
		}
	}

	// --- Locations Slider ---
	const logosElements = document.querySelector('.js-locations-slider')
	logosElements && new Splide('.js-locations-slider', {
		type: 'loop',
		perPage: 2,
		perMove: 1,
		gap: 40,
		pagination: true,
		arrows: false,
		mediaQuery: 'max',
		autoplay: true,
		speed: 1000,
		interval: 3500,
		breakpoints: {
			1023: {
				destroy: true
			},
		},
	}).mount()

	
	// --- Gallery Slider ---
	const galleryElements = document.querySelector('.js-gallery-slider')
	galleryElements && new Splide('.js-gallery-slider', {
		type: 'loop',
		perPage: 1,
		perMove: 1,
		gap: 20,
		pagination: true,
		arrows: false,
		mediaQuery: 'min',
		autoplay: true,
		speed: 1000,
		interval: 3500,
		breakpoints: {
			767: {
				gap: 40,
			},
			1023: {
				perPage: 2,
			},
		},
	}).mount()
}
